import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconsModule } from '../../design/icons.module';
import { StatusChipModule } from '../status-chip/status-chip.module';
import { FileDropComponent } from './file-drop.component';

@NgModule({
  declarations: [FileDropComponent],
  imports: [CommonModule, IconsModule, StatusChipModule],
  exports: [FileDropComponent]
})
export class FileDropModule { }
